import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c8b4e8e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=c8b4e8e4&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=c8b4e8e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b4e8e4",
  null
  
)

export default component.exports